import { BorderTop } from "@material-ui/icons";

const styles = {
  labelIdent: {
    textAlign: "right",
    color:'gray',
    marginTop:'15px',
    fontWeight:'400',
    "@media (max-width: 600px)": {
      textAlign: "left",
      marginTop:'0px',
    },
  },
  containerin:{
    width:'100%'
  },
  container: {
    backgroundColor: '#f0f0f0',
    borderRadius: '12px',
    padding: '16px',
    marginTop: '16px',
    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
    marginBottom: '25px',
  },
  title: {
    marginBottom: '12px',
    fontSize: '18px',
    fontWeight: '600',
    color: '#333',
  },
  linha: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '8px 0',
    borderBottom: '1px solid #ddd',
  },
  linhatop: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '8px 0',
    borderTop: '1px solid #ddd',
  },
  rotulo: {
    color: '#666',
    fontWeight: '500',
  },
  valor: {
    color: '#000',
    fontWeight: '500',
  },
};

export default styles;